import styled from "styled-components";

export const TestimonialsWrapper = styled.section`
    background: var(--white);

    .testimonials-grid {
        row-gap: 20px;
    }

    .testimonial-card {
        width: 100%;
        aspect-ratio: 3 / 4;
        border-radius: 12px;
        overflow: hidden;
        cursor: pointer;
        box-shadow: 0px 8px 24px rgba(15, 54, 149, 0.12);
        transition: transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;

        &:hover {
            transform: translateY(-4px);
            box-shadow: 0px 12px 32px rgba(15, 54, 149, 0.2);
        }

        .custom-img,
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
`;

export const SliderOuter = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
`;

export const SliderWrapper = styled.div`
    position: relative;
    padding: 0 60px 45px;

    .slider-arrow {
        position: absolute;
        top: 42%;
        transform: translateY(-50%);
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: var(--white);
        border: 2px solid var(--lightBlue);
        box-shadow: 0 4px 16px rgba(15, 54, 149, 0.15);
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: var(--darkBlue);
        transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

        &:hover {
            background: var(--lightBlue);
            color: var(--white);
            box-shadow: 0 6px 20px rgba(6, 139, 220, 0.35);
        }
    }

    .slider-arrow-prev {
        left: 0;
    }

    .slider-arrow-next {
        right: 0;
    }

    .testimonials-swiper {
        padding: 24px 0 40px;
        overflow: hidden;
    }

    .swiper-slide {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .slider-card {
        width: 100%;
        aspect-ratio: 3 / 4;
        transform: scale(0.78);
        opacity: 0.55;
        transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1),
            opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1),
            box-shadow 0.5s ease,
            border 0.5s ease;
        border: 2px solid transparent;

        &:hover {
            transform: scale(0.8);
        }
    }

    .swiper-slide-active .slider-card {
        transform: scale(1);
        opacity: 1;
        box-shadow: 0px 12px 40px rgba(6, 139, 220, 0.35);
        border: 2px solid var(--lightBlue);

        &:hover {
            transform: scale(1.02);
            box-shadow: 0px 16px 48px rgba(6, 139, 220, 0.45);
        }
    }

    .swiper-pagination-bullet {
        background: var(--darkBlue);
        opacity: 0.35;
    }

    .swiper-pagination-bullet-active {
        background: var(--lightBlue);
        opacity: 1;
    }
`;

export const LightboxOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

export const LightboxContent = styled.div`
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 100%;
        max-height: 90vh;
        object-fit: contain;
        border-radius: 8px;
    }
`;

export const LightboxClose = styled.button`
    position: fixed;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: var(--white);
    font-size: 36px;
    cursor: pointer;
    line-height: 1;
    z-index: 10000;
    padding: 4px 12px;

    &:hover {
        opacity: 0.8;
    }
`;

export const LightboxNav = styled.button`
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.15);
    border: none;
    color: var(--white);
    font-size: 28px;
    cursor: pointer;
    padding: 12px 16px;
    border-radius: 8px;
    z-index: 10000;
    transition: background 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
    }

    &.prev {
        left: 16px;
    }

    &.next {
        right: 16px;
    }
`;
